import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsChuyenNganhDaoTao } from '../../services/danhmuc';

const ChuyenNganhDaoTaoSelectBox = ({ value, disabled, onChange }: { value?: number, disabled?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsChuyenNganhDaoTao(); 
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn chuyên ngành đào tạo--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            onChange={(e: number) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
            disabled={disabled}
        />
    );
};

export default ChuyenNganhDaoTaoSelectBox;
